// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"323c85c6","396":"92b03c02"}[chunkId] + ".chunk.js";
};